import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './turncate.pipe';
import { TruncateToTwoLinesDirective } from './turncate-twolines.pipe';

@NgModule({
  declarations: [TruncatePipe, TruncateToTwoLinesDirective], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [TruncatePipe, TruncateToTwoLinesDirective], // ✅ Export the pipe for use in other modules
})
export class TruncateModule {}
